import { useMutation } from '@apollo/client';
import { Mutation, MutationOnboardingChooseProviderArgs, Provider } from 'graphql/generated/graphqlTypes';
import { CHOOSE_PROVIDER } from 'graphql/mutations';
import { setCurrentTenantAction } from 'state/actions/currentTenant';
import { BaseHookProps } from '../shared/types';

const useChooseProvider = ({ handleFetchError }: BaseHookProps) => {
  const [chooseProviderMutation, { loading }] = useMutation<
    Pick<Mutation, 'onboardingChooseProvider'>,
    MutationOnboardingChooseProviderArgs
  >(CHOOSE_PROVIDER, {
    onCompleted: (data) => {
      setCurrentTenantAction(data.onboardingChooseProvider);
    },
    onError: () => {
      handleFetchError('Error while choosing provider');
    }
  });

  const chooseProvider = async (provider: Provider) => {
    await chooseProviderMutation({
      variables: {
        provider
      }
    });
  };

  return {
    loading,
    chooseProvider
  };
};

export default useChooseProvider;
